// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getAddressFieldsDataView } from "@insite/client-framework/Store/Data/AddressFields/AddressFieldsSelector";
import loadAddressFields from "@insite/client-framework/Store/Data/AddressFields/Handlers/LoadAddressFields";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import loadCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getCurrentCountries } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import loadCurrentCountries from "@insite/client-framework/Store/Data/Countries/Handlers/LoadCurrentCountries";
import {
    getCurrentPromotionsDataView,
    getPromotionsDataView,
} from "@insite/client-framework/Store/Data/Promotions/PromotionsSelectors";
import { chain, LoadData } from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/LoadDataIfNeeded";

/**
 * XNG-Changes
 * Add ForeRequest option
 */
const XngLoadData: typeof LoadData = props => {
    const state = props.getState();
    if (!getCurrentCountries(state)) {
        props.dispatch(loadCurrentCountries());
    }
    if (!getAddressFieldsDataView(state).value) {
        props.dispatch(loadAddressFields());
    }

    const { cartId, forceRequest } = props.parameter as { forceRequest?: boolean } & typeof props.parameter;
    if (cartId) {
        const cartState = getCartState(state, cartId);
        if ((!cartState.value && !cartState.isLoading) || forceRequest) {
            const promotionsState = getPromotionsDataView(state, cartId);
            const shouldLoadPromotions = !promotionsState.value && !promotionsState.isLoading;
            props.dispatch(loadCart({ cartId, getPromotions: shouldLoadPromotions, shouldLoadFullCart: true }));
        }
    } else {
        const currentCartState = getCurrentCartState(state);
        if (
            ((!currentCartState.value ||
                (currentCartState.value.lineCount && !currentCartState.value.cartLines?.length) ||
                !currentCartState.value.carriers) &&
                !currentCartState.isLoading) ||
            forceRequest
        ) {
            const currentPromotionsState = getCurrentPromotionsDataView(state);
            const shouldLoadPromotions = !currentPromotionsState.value && !currentPromotionsState.isLoading;
            props.dispatch(loadCurrentCart({ getPromotions: shouldLoadPromotions, shouldLoadFullCart: true }));
        }
    }
};

replaceInChain(chain, LoadData, XngLoadData);
